<template>
    <div>
        <vue-qr :text="downloadData.url" :margin="10" colorDark="#000" colorLight="#fff" :dotScale="1" :logoSrc="downloadData.icon" :logoScale="0.2" :size="140"></vue-qr>
    </div>
</template>
<script>
import vueQr from 'vue-qr'
export default {
    components: {
        vueQr
    },props:{
        downloadData:{
            type:Object,
            default:{},
        }
    },
    data() {
        return {}
    }
}
</script>
<style lang="less" scoped>
    
</style>


// WEBPACK FOOTER //
// src/components/parts/h-qr-code.vue